{
  "previous": "Précédent",
  "next": "Suivant",
  "complete": "Terminer",
  "verifyAndCheckIn": "Vérifier et s'enregistrer",
  "loading": {
    "retrievingLocation": "Récupération de la localisation...",
    "retrievingWarehouse": "Récupération des données de l'entrepôt..."
  },
  "validation": {
    "fieldRequired": "Ce champ est obligatoire",
    "fieldRequiredWithLabel": "{label} est obligatoire",
    "phoneInvalid": "Ce numéro de téléphone n'est pas valide",
    "phoneInvalidWithExample": "Ce numéro de téléphone n'est pas valide (exemple : {example})"
  }
}
